import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './stream-configuration.delete-many.reducer';
import {StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';

export const deleteManyStreamConfigurationsFeatureKey = 'deleteManyStreamConfigurations';
export const featureSelector = createFeatureSelector<State>(deleteManyStreamConfigurationsFeatureKey);

export const getDeleteManyStreamConfigurationsRecord = createSelector(
  featureSelector,
  (state: State): StreamConfiguration[] => state.record
);

export const getDeleteManyStreamConfigurationsLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getDeleteManyStreamConfigurationsLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getDeleteManyStreamConfigurationsError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
